import url from './url';
import moment from './moment';
import currency from './currency';
import response from './response';
import stringUtils from './string';

export default {
  url,
  moment,
  currency,
  response,
  validateEmail: stringUtils.validateEmail,
};
